export default {
  toolbar: {
    flex: 1,
    alignItems: 'center',
    minHeight: 'unset',
    marginTop: 10,
    marginBottom: 10,
  },
  actions: {
    paddingTop: 0,
    paddingBottom: 0,
    minHeight: 'unset',
  },
};
